import { useEffect } from 'react';
/**
 * Global keyboard handler for region-based navigation.
 * Ctrl+Shift+[Number] focuses the corresponding region container.
 * Once focused, the existing roving tabindex handles Enter/Escape/Arrow navigation.
 *
 * Uses Ctrl+Shift+Number because:
 * - VoiceOver intercepts Alt+Shift+Letter as quick nav commands
 * - JAWS uses Alt+Number for heading level navigation
 * - Ctrl+Shift+1..5 is free across VoiceOver, JAWS, NVDA, and all browsers
 *
 * Regions are found via CSS selector — no ref drilling needed.
 * Each region container must have tabIndex={-1} to receive focus.
 */
export var useRegionNavigation = function (regions) {
    useEffect(function () {
        var handleKeyDown = function (e) {
            if (!(e.ctrlKey || e.metaKey) || !e.shiftKey)
                return;
            // Reject if Alt is also held
            if (e.altKey)
                return;
            // Skip when typing in inputs
            var activeEl = document.activeElement;
            if (activeEl &&
                (activeEl.tagName === 'INPUT' ||
                    activeEl.tagName === 'TEXTAREA' ||
                    activeEl.tagName === 'MATH-FIELD' ||
                    activeEl.isContentEditable ||
                    !!activeEl.closest('[contenteditable="true"]') ||
                    !!activeEl.closest('math-field'))) {
                return;
            }
            // Skip when a modal/dialog is open
            if (document.querySelector('[role="dialog"]:not([aria-hidden="true"])'))
                return;
            var pressedCode = e.code.toLowerCase();
            for (var _i = 0, regions_1 = regions; _i < regions_1.length; _i++) {
                var region = regions_1[_i];
                if (pressedCode === region.key) {
                    var el = document.querySelector(region.selector);
                    if (el) {
                        e.preventDefault();
                        e.stopPropagation();
                        el.focus();
                    }
                    return;
                }
            }
        };
        document.addEventListener('keydown', handleKeyDown, true);
        return function () { return document.removeEventListener('keydown', handleKeyDown, true); };
    }, [regions]);
};
